import React from 'react';
import { ColorScheme } from 'ia-react-core/~/interfaces/ColorScheme';

import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';

const ColorSchemeContext = React.createContext<{
  scheme: ColorScheme;
}>({ scheme: COLOR_SCHEMES.LIGHT });

/**
 * @component
 * @visibleName ColorSchemeContext
 */
export default ColorSchemeContext;
